import gql from "graphql-tag";

export const MY_TIME_APPROVE_ALL_REQUESTS = gql`
  mutation approveAllMyTimeRequests($contractCode: String!) {
    approveAllMyTimeRequests(contractCode: $contractCode) {
      result
      message
    }
  }
`;
